import { render, staticRenderFns } from "./setMaklumatPeribadi.vue?vue&type=template&id=639b9441&"
import script from "./setMaklumatPeribadi.vue?vue&type=script&lang=js&"
export * from "./setMaklumatPeribadi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports